module.exports = __webpack_public_path__ + "img/404.7b2ffdfb.svg";